module.exports = __webpack_public_path__ + "static/media/o1.912eb056.png";